import bus from '@/views/eventBus'

const app = {
  state: {
    loading: false
  },
  
  mutations: {
    LOADING_STATUS: (state, status) => {
      state.loading = status
    }
  },
  
  actions: {
    loadingStatus({ commit }, status) {
      commit('LOADING_STATUS', status)
    },

    // 全局播放
    async playBack({ commit }, {id, list}) {
      const { data: res } = await bus.$http.get("/playBack", { params: { u_id: window.sessionStorage.getItem('userID'), m_id: id }});
      // console.log(id, list);
      if (res.code !== 200) return this.$message.error("获取播放歌曲信息失败");
      // bus.$emit("playMusic", res);
      bus.$emit("playMusic", [res, list]);
    },
  }
}

export default app
